import React from "react";
import "./MainContent.scss";
export default function MainContent({ children }) {
  return (
    <section
      className={`grid grid-cols-1 min-h-screen bg-gray-900 main-content-dashboard`}
    >
      {children}
    </section>
  );
}
